import { ISearchResult } from '../../state-helpers/search-results';
import * as React from 'react';
import * as Moment from 'moment';
import * as Redux from 'redux';
import { IState } from '../../reducers/index';

export interface ISearchResultProps {
    result: ISearchResult;
    dispatch: Redux.Dispatch<IState>;
    
    onClick: (hitId: string) => void;
}


export interface ISearchResultTemplateProps {
    result: ISearchResult;
    dispatch: Redux.Dispatch<IState>;

    onClick: () => void;
}

var htmlEncode = function (stringToEncode) {
    return { __html: stringToEncode };
}

export class SearchResult extends React.Component<ISearchResultProps, any> {
    render() {
        var searchResultTemplate;
        const hitOnClick = () => this.props.onClick(this.props.result.hitId);

        searchResultTemplate = <SearchResultGeneral result={this.props.result} dispatch={this.props.dispatch} onClick={hitOnClick} />;
        return (
            <li className="search-result-item-wrapper">
                {searchResultTemplate}
            </li>
        )
    }
}

export class SearchResultGeneral extends React.Component<ISearchResultTemplateProps, any>{

    getTarget() {
        if (this.props.result.openInNewTab)
            return "_blank";
        else
            return "_self";
    }

    render() {
        return (
            <a className="search-result-item" href={this.props.result.friendlyUrl} target={this.getTarget()} onClick={this.props.onClick} >
                <h4 className="search-result-title" dangerouslySetInnerHTML={htmlEncode(this.props.result.title)}></h4>

                {this.props.result.shortDescription &&
                    <p className="search-result-content" dangerouslySetInnerHTML={{ __html: this.props.result.shortDescription }}></p>
                }

                {<span className="search-result-permalink">
                    {this.props.result.friendlyUrl}
                </span>}


                {this.props.result.revisedDate &&
                    <p className='search-result-excerpt-date'>{this.props.result.revisedDate}</p>
                }
            </a>
        )
    }
}
